import { EN_158042012_ID, ISO_14025_ID, ISO_21930_ID, NORTH_AMERICA_PILOT_PCR } from 'components/v2/compiler/constants';
import { useEffect, useState } from 'react';
import EpdService from 'services/EpdService';
import { DictionaryValue } from 'types/types';

const useConformityStandards = (pcr?: {
  id?: string;
  isConstruction?: boolean;
  isISO219302017Available?: boolean;
  isEN158042012A2Available?: boolean;
}) => {
  const [conformityStandards, setConformityStandards] = useState<DictionaryValue[]>([]);

  useEffect(() => {
    const fetchConformityStandards = async () => {
      try {
        const result = await EpdService.getConformityStandards();
        setConformityStandards(result);
      } catch (error) {
        console.error('Failed to fetch conformity standards:', error);
      }
    };

    fetchConformityStandards();
  }, []);

  const isPilotNorthAmericaPcr = pcr?.id?.toLowerCase() === NORTH_AMERICA_PILOT_PCR;

  const isConformityStandardDisabled = (standardId: string): boolean => {
    if (standardId === ISO_14025_ID) {
      return false;
    }

    if (pcr?.isConstruction) {
      return false;
    }

    if (standardId === EN_158042012_ID) {
      return !pcr?.isEN158042012A2Available;
    }

    if (standardId === ISO_21930_ID) {
      return !pcr?.isISO219302017Available && !isPilotNorthAmericaPcr;
    }

    return true;
  };

  return conformityStandards.map((x) => ({
    value: x.key.toString(),
    label: x.value,
    isDisabled: isConformityStandardDisabled(x.key.toString()),
  }));
};

export default useConformityStandards;
